/*const SITE = {
  url: 'https://sarudoli.axiohm.cz/uploads/maps/'
}*/

const PINS_ATTACHMENTS_URL =
  'https://sarudoli.axiohm.cz/uploads/pinAttachments/';

const DRAWING_PRINT_BASE_URL = 'https://sarudoli.axiohm.cz/export/layer/';
const DRAWING_PINS_PRINT_BASE_URL = 'https://sarudoli.axiohm.cz/export/pins/';
const DRAWING_AND_SUBDRAWING_PINS_PRINT_BASE_URL =
  'https://sarudoli.axiohm.cz/export/all-sublayers-pins/';
const SINGLE_PIN_PRINT_BASE_URL =
  'https://sarudoli.axiohm.cz/export/single-pin/';

export {
  PINS_ATTACHMENTS_URL,
  DRAWING_PRINT_BASE_URL,
  DRAWING_AND_SUBDRAWING_PINS_PRINT_BASE_URL,
  DRAWING_PINS_PRINT_BASE_URL,
  SINGLE_PIN_PRINT_BASE_URL
};
